export const isArray = value => Array.isArray(value);

export const find = (value, cb) => isArray(value) && value.find(cb);
